import { useParams, Link } from 'react-router-dom';
import './../../pagescss/SubjectTopics.css';
import Number from './../topics/QuizNumber';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import { useState } from 'react';
import { useEffect } from 'react';


function QuizNumber() {
    const { type, subject, topic, subjectName } = useParams();
    const [submissions, setSubmissions] = useState([]);
    const  filterByPhoneAllQuizSubmissions = submissions;

    useEffect(() => {
        const saved = localStorage.getItem('quizSubmissions');
        const data = saved ? JSON.parse(saved) : [];
        setSubmissions(data);
    }, []);



    let quizLimit;
    if (subject !== "atoz" && topic !== "atoz") {
        quizLimit = 10;
    } else if (subject !== "atoz" && topic === "atoz") {
        quizLimit = 100;
    } else {
        quizLimit = 200;
    }

  //  if (loading) {
  //      return <Loading message='Loading......' />;
   // }

    return (
        <div className="subject-topics-page">


            {subject === "atoz" ? (
                <><TopNavbar name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopNavbar name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopNavbar name={"Full mock test for " + subjectName} /></>
                )
            )}

            {subject === "atoz" ? (
                <><TopHeader name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopHeader name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopHeader name={"Full mock test for " + subjectName} /></>
                )
            )}

            <div className="topics-container">
                {Number.slice(0, quizLimit).map((quizNum, index) => {
                    const quizId = `${type}${subject}${topic}${quizNum.quizNo}`;
                    const userSubmission = filterByPhoneAllQuizSubmissions?.find(
                        submission => submission.quizId === quizId
                    );
                    const isUserQuiz = !!userSubmission;

                    // Safely extract data with fallbacks
                    const score = isUserQuiz ? (userSubmission?.score || 0) : null;
                    const totalQuestions = isUserQuiz ? (userSubmission?.totalQuestions || 0) : null;
                    const percentage = isUserQuiz && totalQuestions > 0
                        ? Math.round((score * 100) / (totalQuestions * 4))
                        : 0;

                    return (
                        <div key={quizNum.id || quizNum.quizNo}>
                            

                                    {isUserQuiz ? (
                                        <Link
                                            to={`/quiz-details/${quizId}`}
                                            className="link"
                                        >
                                            <div className="topic-card-mocktest-complete">

                                                <div className="topic-header">
                                                    <h2>📋{quizNum.quizNo}: {subjectName} mock test</h2>
                                                </div>
                                                <p>Complete: Score: {score}/{totalQuestions * 4} ({percentage}%)</p>
                                            </div>
                                        </Link>
                                    ) : (
                                        <Link
                                            to={`/number-of-questions/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}
                                            className="link"
                                        >
                                            <div className="topic-card">
                                                <div className="topic-header">
                                                    <h2>📋{quizNum.quizNo}: {subjectName} mock test</h2>
                                                </div>
                                            </div>
                                        </Link>
                                    )}

                               

                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default QuizNumber;